{
	"transactionCardHeader": "Eine Transaktion validieren",
	"transactionCardDescriptionBold": "Sie möchten eine Transaktion für ein beliebiges Projekt validieren?",
	"transactionCardDescriptionRegular": "Wenn Sie eine Transaktionsnummer zur Hand haben, können Sie diese hier eingeben und die Transaktion validieren.",
	"showTransactionButton": "Transaktion anzeigen",
	"transactionLabel": "Transaktionsnummer",
	"errors": {
		"transactionIdRequired": "Transaktionsnummer ist erforderlich.",
		"transactionNotFound": "Transaktion nicht gefunden.",
		"transactionIdInvalid": "Ungültige Transaktionsnummer."
	}
}
